import { createAction, props } from '@ngrx/store';
import { ActionTypes } from './action-types';
import { ZohoSignInPayload } from "../zoho-auth.service";

export const zohoSignInAction = createAction(
  ActionTypes.ZOHO_SIGN_IN,
  props<{ payload: ZohoSignInPayload }>()
);

export const zohoSignInSuccessAction = createAction(
  ActionTypes.ZOHO_SIGN_IN_SUCCESS,
  props<{ data: any }>()
);

export const zohoSignInFailureAction = createAction(
  ActionTypes.ZOHO_SIGN_IN_FAILURE,
  props<{ error: any }>()
);

export const zohoSignOutAction = createAction(
  ActionTypes.ZOHO_SIGN_OUT,
  props<{ payload: { integrationId: string } }>()
);

export const zohoSignOutSuccessAction = createAction(
  ActionTypes.ZOHO_SIGN_OUT_SUCCESS,
);

export const zohoSignOutFailureAction = createAction(
  ActionTypes.ZOHO_SIGN_OUT_FAILURE,
  // TODO: Add type
  props<{ error: any }>()
);
